@if(component){
<div class="flex wrap flex-column-s flex-column-m w-12 p-t-10-l p-b-10-l p-t-20-x p-b-20-x p-t-8 p-b-8"
     [ngClass]="component.textPosition === 'right' ? 'flex-reverse flex-column-reverse-s flex-column-reverse-m' : ''">
    <text-box class="w-6 w-12-s w-12-m flex flex-middle"
              [ngClass]="component.textPosition === 'right' ? 'p-l-10-l p-l-30-x' : 'p-r-10-l p-r-30-x'"
              [data]="component"></text-box>
    <div class="w-6 w-12-s w-12-m m-b-5-m m-b-5-s m-t-4-s m-t-4-m">
        @if(!component.fewImages){
        @for(image of component.images; track image){
        <ng-container *ngTemplateOutlet="content, context: { $implicit: image}"></ng-container>
        }
        }@else{
        <ng-container *ngTemplateOutlet="fewImagesGrid"></ng-container>
        }
    </div>
</div>
}

<ng-template #fewImagesGrid>
    <div [grid]="2"
         [gridColumnGap]="client.sizeId > 1 ? '20px' : '8px'"
         [gridRowGap]="client.sizeId > 1 ? '20px' : '8px'">
        @for(image of component?.images; track image){
        <ng-container *ngTemplateOutlet="content, context: { $implicit: image, index: $index}"></ng-container>
        }
    </div>
</ng-template>

<ng-template #content
             let-image
             let-index='index'>
    <div class="overflow-hidden pos-relative"
         style="border-radius: 12px;"
         [ngClass]="[!index || index === 2 ? '' :  '_grid-span']"
         [style.aspect-ratio]="!index || index === 2 ? '3/2' : '2/3'">

        <!-- image -->
        @if(image?.backgroundImage){
        <df-image-wrapper class="w-12"
                          style="border-radius: 12px;">
            <!-- alt="" is deliberate: this is a presentational backdrop that
                 sits behind the block's own video and copy -->
            <img class="z-1 w-12"
                 [ratio]="!index || index === 2 ? '3/2' : '2/3'"
                 [dfImage]="image.backgroundImage"
                 alt="">
        </df-image-wrapper>
        }


        @if(image.videoId){
        @if(image?.videoProvider === 'youtube'){
        <youtube-player class="z-2"
                        [video-id]="image.videoId"
                        [autoplay-in-viewport]="image.videoAutoplay"
                        [background]="image.videoBackground">
            <!-- play icon -->
            <ng-template #playButton>
                <i class="icon-play"></i>
            </ng-template>

            <!-- pause icon -->
            <ng-template #pauseButton>
                <i class="icon-pause"></i>
            </ng-template>
        </youtube-player>
        }

        @if(image?.videoProvider === 'vimeo'){
        <vimeo-player class="z-2"
                      [video-id]="image.videoId"
                      [autoplay-in-viewport]="image.videoAutoplay"
                      [background]="image.videoBackground">
            <!-- play icon -->
            <ng-template #playButton>
                <i class="icon-play"></i>
            </ng-template>

            <!-- pause icon -->
            <ng-template #pauseButton>
                <i class="icon-pause"></i>
            </ng-template>
        </vimeo-player>
        }
        }
    </div>
</ng-template>